import React from "react";
import Drawer from "@mui/material/Drawer";

interface MobileMenuDrawerProps {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const MobileMenuDrawer: React.FC<MobileMenuDrawerProps> = ({
                                                               open,
                                                               onClose,
                                                               children
                                                           }) => {
    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            hideBackdrop={false}
            disableScrollLock={true}
            keepMounted
            transitionDuration={{enter: 200, exit: 200}}
            ModalProps={{
                sx: {
                    marginTop: '70px',
                    '& .MuiBackdrop-root': {marginTop: '70px'},
                    '& .MuiDrawer-paper': {
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: '16px',
                        marginTop: '70px',
                        height: 'calc(100% - 70px)',
                        boxShadow: 'none',
                    }
                }
            }}
            slotProps={{
                transition: {
                    appear: true,
                    easing: {enter: "cubic-bezier(0, 0, 0.2, 1)", exit: "cubic-bezier(0, 0, 0.2, 1)"}
                }
            }}
        >
            {children}
        </Drawer>
    );
};

export default MobileMenuDrawer;